import { getAuth } from 'firebase/auth';
import { useCallback, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useServiceMode } from 'src/contexts/ServiceModeContext';
import useAuthedRequest from 'src/hooks/useAuthedRequest';
import { getPayloadJWT, isJWT } from 'src/utils/jwt';

export const OrganizationLockGuard = () => {
  const auth = getAuth();
  const { get } = useAuthedRequest();
  const { serviceKey } = useServiceMode();
  const navigate = useNavigate();

  const fetchCurrentUserAndOrganization = useCallback(async () => {
    const token = await auth.currentUser?.getIdToken();

    if (token && isJWT(token) && !serviceKey) {
      const decoded = getPayloadJWT(token);

      if (decoded.organization) {
        const organization = await get(
          `/organizations/${decoded.organization.id}`,
        );
        if (
          !!organization.lockAt &&
          new Date(organization.lockAt).getTime() < new Date().getTime()
        ) {
          navigate('/billing?error=plan-expired');
        }
      }
    }
  }, [auth, get, navigate, serviceKey]);

  useEffect(() => {
    if (!auth) {
      return;
    }

    fetchCurrentUserAndOrganization();
  }, [auth, fetchCurrentUserAndOrganization]);

  return <Outlet />;
};
